import state from './jobcode.state'

const getters = {
  skipBtn: state => state.skipBtn,
  landscapeScreen: state => state.landscapeScreen,
  potraitScreen: state => state.potraitScreen,
  interviewTracking: state => state.interviewTracking,
  companyInfo: state => state.companyInfo,
  recruiterInfo: state => state.recruiterInfo,
  quesBox: state => {
    return state.quesBox
  },
  videoPercentage: state => {
    return state.videoPercentage
  },
  uploadProgress: state => {
    return state.uploadProgress
  },
  recordingPercentage: state => {
    return state.recordingPercentage
  },
  updateJobC: state => {
    return state.updateJobC
  },
  publishJobC: state => {
    return state.publishJobC
  },
  jobcode: state => {
    return state.jobcode
  },
  uploadedVideoAnswers: state => {
    return state.uploadedVideoAnswers
  },
  trimmedInformation: state => {
    return state.trimmedInformation
  },
  allowedBrowsersList: state => {
    return state.allowedBrowsersList
  }
}

export default getters
